module.exports = __webpack_public_path__ + "img/logo_dark.f5a75bd5.png";